module.exports = __webpack_public_path__ + "media/images/area/area_fukushimaM400-fb690d3ef4145e4e31b3072452c56699.jpg";